import { ReactElement, ReactNode } from "react";

export function CompareSubMetric(props: {
  name: string;
  valueLeft: number | undefined;
  valueRight: number | undefined;
  children?: ReactNode;
}): ReactElement {
  return (
    <>
      <div className="pl-8 text-sm text-gray-600">{props.name}</div>
      <div className="text-right text-sm text-gray-500">
        {props.valueLeft !== undefined
          ? props.valueLeft.toLocaleString("de-CH", {
              maximumFractionDigits: 2,
            })
          : ""}
      </div>
      <div className="text-right text-sm text-gray-500">
        {props.valueRight !== undefined
          ? props.valueRight.toLocaleString("de-CH", {
              maximumFractionDigits: 2,
            })
          : ""}
      </div>
      <div className="text-right text-sm text-gray-500">
        {props.valueLeft !== undefined && props.valueRight !== undefined
          ? (props.valueRight - props.valueLeft).toLocaleString("de-CH", {
              maximumFractionDigits: 2,
            })
          : ""}
      </div>
    </>
  );
}
